




















import Vue from "vue";

export default Vue.extend({
  name: "WorkExperience",
  props: {
    work: {
      type: Object,
      required: true,
      default: () => ({
        title: "",
        company: "",
        startDate: "",
        endDate: "",
        responsibilities: [],
        techStack: [],
      }),
    },
  },

  methods: {
    getStringFromStack: function(techStack: string[]) {
      return techStack.join(", ");
    },
  },
});
